// extracted by mini-css-extract-plugin
export var cardWrapper = "_47-0";